export const POST_EMAIL_VERIFICATION_RELOAD_KEY = 'rewardbloom:post-email-verification-reload';
